module.exports = __webpack_public_path__ + "static/media/reguas-de-marcas-UNA-SUS_unasusufma.ceab26e9.png";